import numeral from 'numeral'

var country_mz = null
var language_mz = null

export function getCountry() {
  if (country_mz == null) {
    country_mz = document.querySelector('html').dataset.country
  }
  return country_mz
}

export function getLanguage() {
  if (language_mz == null) {
    language_mz = document.querySelector('html').getAttribute('lang')
  }
  return language_mz
}

export function t(key) {
  return window.leg_locales[key];
}

export function formatNumber(value) {
  switch (getLanguage()) {
    case 'fr':
    case 'ch':
      return numeral(value).format('0.00').replace('.', ',')
    default:
      return numeral(value)
  }
}

export function formatToCurrency(value) {
  var value_formatted = formatNumber(value)
  switch (getLanguage()) {
    case 'fr':
      return value_formatted + " €"
    case 'ch':
      return value_formatted + " CH"
    default:
      return value_formatted
  }
}

export function parseString(value) {
  value = value.replace('€', '')
  value = value.replace(' ', '')
  switch (getLanguage()) {
    case 'fr':
    case 'ch':
      return parseFloat(value.replace(',', '.'))
    default:
      return parseFloat(value)
  }
}

export function secondsToHours(seconds) {
  var date = new Date(1970, 0, 1)
  date.setSeconds(seconds)
  return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1")
}

export function minutesToHours(minutes, without_minutes = false) { // without_minutes pour les axes Y des charts
  let h = Math.floor(minutes / 60)
  let m = minutes % 60
  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  if (without_minutes)
    return `${h} h`
  else
    return `${h} h ${m}`
}

export function isBlank(v) {
  return v === null || v === undefined || v.trim() === ''
}

export function isNumber(v) {
  return typeof v === 'number' && !isNaN(v)
}

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
// https://vanillajstoolkit.com/helpers/serialize/
export function serialize(form) {

  // Setup our serialized data
  var serialized = [];

  // Loop through each field in the form
  for (var i = 0; i < form.elements.length; i++) {

    var field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    }

    // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }
  return serialized.join('&');
};